import * as React from "react";

import { useMyBagPresentationModel } from "../providers";

import {
  AddressFormFragment,
  AddressFormFragmentProps,
} from "./delivery-details-address-form-fragment";
import { ReactCheckout2022_AddressFormTypes } from "./delivery-details-address-form-types";

interface DeliveryAddressProps {
  formRef: AddressFormFragmentProps["formRef"];
  formRef_isBillingAndShippingTheSame: AddressFormFragmentProps["formRef_isBillingAndShippingTheSame"];
}
export const DeliveryAddress: React.FunctionComponent<DeliveryAddressProps> = (
  props
) => {
  const { presentationMyBagOrder } = useMyBagPresentationModel();

  if (presentationMyBagOrder?.isThisAVirtualOrder) {
    return null;
  }

  return (
    <AddressFormFragment
      addressFormType={ReactCheckout2022_AddressFormTypes.shipping}
      title="Delivery Address"
      formRef={props.formRef}
      formRef_isBillingAndShippingTheSame={
        props.formRef_isBillingAndShippingTheSame
      }
    />
  );
};
